import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { nameregex, pecentageregex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import { GrUploadOption } from "react-icons/gr";
import { addCarType } from "../store/slices/carType";

const AddCar = () => {
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;
  const [carName, setcarName] = useState("");
  const [carImage, setcarImage] = useState("");
  const [minMember, setminMember] = useState("");
  const [maxMember, setmaxMember] = useState("");
  const [imageError, setImageError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [carType, setcarType] = useState("");
  const [previewImage, setPreviewImage] = useState(""); // New state for image preview
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    switch (name) {
      case "carName":
        setcarName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter a valid car name"
            : "";
        break;

      case "carType":
        setcarType(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select car type " : "";
        break;

      case "minMember":
        const sanitizedValue1 = value.replace(/\D/g, "").slice(0, 2);
        setminMember(sanitizedValue1);
        validationErrors[name] =
          sanitizedValue1 === "" || !pecentageregex.test(sanitizedValue1)
            ? "Please enter valid value"
            : "";

        break;

      case "maxMember":
        const sanitizedValue = value.replace(/\D/g, "").slice(0, 2);
        setmaxMember(sanitizedValue);

        if (sanitizedValue === "" || !pecentageregex.test(sanitizedValue)) {
          validationErrors[name] = "Please enter a valid value";
        } else if (Number(sanitizedValue) < Number(minMember)) {
          validationErrors[name] = "Max member must be greater than min member";
        } else {
          validationErrors[name] = "";
        }
        break;

      default:
        break;
    }

    setErrors(validationErrors);
  };

  const addFerriess = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const validationErrors = {};

    if (!carName.trim()) {
      validationErrors.carName = "Please enter name";
    } else if (!nameregex.test(carName)) {
      validationErrors.carName = "Name must be at least three characters";
    }
    if (!carType) {
      validationErrors.carType = "Please select car type";
    }

    if (!minMember) {
      validationErrors.minMember = "Please enter min member";
    } else if (!pecentageregex.test(minMember)) {
      validationErrors.minMember = "Please enter valid value";
    }
    if (!maxMember) {
      validationErrors.maxMember = "Please enter max member";
    } else if (!pecentageregex.test(maxMember)) {
      validationErrors.maxMember = "Please enter valid value";
    } else if (Number(maxMember) < Number(minMember)) {
      validationErrors.maxMember = "Max member must be greater than min member";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const item = {
      carName,
      carImage,
      minMember,
      maxMember,
      carType,
    };

    try {
      await dispatch(addCarType(item)).unwrap();
      alert("Car types added successfully!");
      navigate("/admin/car-types");
    } catch (error) {
      alert(error);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  async function imageUpload(e) {
    setImageError("");
    const file = e.target.files[0];

    if (!file) {
      setImageError("Please select a file to upload");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setImageError("Please upload an image less than 5 MB");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        "x-access-token": token,
      },
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}${API_PATHS.uploadFile}`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`Upload failed with status: ${response.status}`);
      }

      const data = await response.json();

      if (data?.status === 1 && data?.data?.location) {
        const uploadedimage = data.data.location;
        setcarImage(uploadedimage);
        setPreviewImage(uploadedimage);
        setErrors((prevErrors) => ({ ...prevErrors, image: "" }));
      } else {
        throw new Error(data.message || "Failed to upload image");
      }
    } catch (error) {
      console.error("Image Upload Error:", error.message);
      setImageError(
        error.message || "Something went wrong while uploading the image"
      );
    }
  }

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Ferry Service</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/ferry-services"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Ferry Services
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Ferry Service</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={addFerriess}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Car Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="carName"
                  value={carName}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.carName ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Car Name"
                />
                {errors.carName && (
                  <div className="text-danger mt-2">{errors.carName}</div>
                )}
              </div>
              <div className="col-md-5">
                <label className="form-label">
                  Min Member <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="minMember"
                  value={minMember}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.minMember ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Min. Member"
                />
                {errors.minMember && (
                  <div className="text-danger mt-2">{errors.minMember}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Max Member <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="maxMember"
                  value={maxMember}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.minMember ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Max. Member"
                />
                {errors.maxMember && (
                  <div className="text-danger mt-2">{errors.maxMember}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Car Type <span className="text-danger">*</span>
                </label>
                <select
                  name="carType"
                  value={carType}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.carType ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  <option value="Luxury Car">Luxury Car</option>
                  <option value="Normal Car">Normal Car</option>
                </select>
                {errors.carType && (
                  <div className="text-danger mt-2">{errors.carType}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">Car Image</label>
                <br />
                <label htmlFor="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  name="image"
                  id="fileInput"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                />
                {errors.image && (
                  <div className="text-danger mt-2">{errors.image}</div>
                )}
                <br />
                <img
                  className="mt-3"
                  src={carImage}
                  style={{ height: "60px" }}
                  alt=""
                />
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCar;
